import {

   DEMAND_CATEGORY_CREATE_REQUEST,
   DEMAND_CATEGORY_CREATE_SUCCESS,
   DEMAND_CATEGORY_CREATE_FAIL,

   DEMAND_CATEGORY_UPDATE_RESET,
   DEMAND_CATEGORY_UPDATE_FAIL,
   DEMAND_CATEGORY_UPDATE_SUCCESS,
   DEMAND_CATEGORY_UPDATE_REQUEST,

   DEMAND_CATEGORY_DETAILS_RESET,
   DEMAND_CATEGORY_DETAILS_FAIL,
   DEMAND_CATEGORY_DETAILS_SUCCESS,
   DEMAND_CATEGORY_DETAILS_REQUEST,

   DEMAND_CATEGORY_DETAILS_REVENUE_RESET,
   DEMAND_CATEGORY_DETAILS_REVENUE_FAIL,
   DEMAND_CATEGORY_DETAILS_REVENUE_SUCCESS,
   DEMAND_CATEGORY_DETAILS_REVENUE_REQUEST,

   CATEGORY_TEMPLATES_REQUEST,
   CATEGORY_TEMPLATES_SUCCESS,
   CATEGORY_TEMPLATES_FAIL,

   CATEGORY_NAMES_FOR_LGA_REQUEST,
   CATEGORY_NAMES_FOR_LGA_SUCCESS,
   CATEGORY_NAMES_FOR_LGA_FAIL,

   CATEGORY_NAME_VALIDATE_REQUEST,
   CATEGORY_NAME_VALIDATE_SUCCESS,
   CATEGORY_NAME_VALIDATE_FAIL,

} from '../constants/demandCategoryConstants.js';




export const demandCategoryCreateReducer = (state = {}, action) => {
   //   const { type, payload } = action
   switch (action.type) {
      case DEMAND_CATEGORY_CREATE_REQUEST:
         return { loading: true };
      case DEMAND_CATEGORY_CREATE_SUCCESS:
         return { loading: false, demand_category: action.payload, success: true };
      case DEMAND_CATEGORY_CREATE_FAIL:
         return { loading: false, error: action.payload };
      default:
         return state;
   }
};



export const demandCategoryDetailsReducer = (state = {}, action) => {
   //   const { type, payload } = action
   switch (action.type) {
      case DEMAND_CATEGORY_DETAILS_REQUEST:
         return { ...state, loading: true };
      case DEMAND_CATEGORY_DETAILS_SUCCESS:
         if (action.payload === undefined) {
            action.payload = {};
         }
         return { loading: false, demand_category: action.payload };

      case DEMAND_CATEGORY_DETAILS_FAIL:
         return { loading: false, error: action.payload };
      case DEMAND_CATEGORY_DETAILS_RESET:
         return { demand_category: {} };
      default:
         return state;
   }
};
export const demandCategoryDetailsRevenueReducer = (state = {}, action) => {
   //   const { type, payload } = action
   switch (action.type) {
      case DEMAND_CATEGORY_DETAILS_REVENUE_REQUEST:
         return { ...state, loading: true };
      case DEMAND_CATEGORY_DETAILS_REVENUE_SUCCESS:
         if (action.payload === undefined) {
            action.payload = {};
         }
         return { loading: false, demand_category: action.payload };

      case DEMAND_CATEGORY_DETAILS_REVENUE_FAIL:
         return { loading: false, error: action.payload };
      case DEMAND_CATEGORY_DETAILS_REVENUE_RESET:
         return { demand_category: {} };
      default:
         return state;
   }
};

export const demandCategoryUpdateReducer = (state = { demand_category: {} }, action) => {
   switch (action.type) {
      case DEMAND_CATEGORY_UPDATE_REQUEST:
         return { loading: true };
      case DEMAND_CATEGORY_UPDATE_SUCCESS:
         return { loading: false, success: true, demand_category: action.payload };
      case DEMAND_CATEGORY_UPDATE_FAIL:
         return { loading: false, error: action.payload };
      case DEMAND_CATEGORY_UPDATE_RESET:
         return { demand_category: {} };
      default:
         return state;
   }
};

export const categoryTemplatesReducer = (state = { templates: [] }, action) => {
   switch (action.type) {
      case CATEGORY_TEMPLATES_REQUEST:
         return { loading: true, templates: [] };
      case CATEGORY_TEMPLATES_SUCCESS:
         return { loading: false, templates: action.payload };
      case CATEGORY_TEMPLATES_FAIL:
         return { loading: false, error: action.payload, templates: [] };
      default:
         return state;
   }
};

// NEW: Reducer for fetching category names for LGA (includes existing + templates)
export const categoryNamesForLgaReducer = (state = { categoryNames: null }, action) => {
   switch (action.type) {
      case CATEGORY_NAMES_FOR_LGA_REQUEST:
         return { loading: true, categoryNames: null };
      case CATEGORY_NAMES_FOR_LGA_SUCCESS:
         return { loading: false, categoryNames: action.payload };
      case CATEGORY_NAMES_FOR_LGA_FAIL:
         return { loading: false, error: action.payload, categoryNames: null };
      default:
         return state;
   }
};

export const categoryNameValidateReducer = (state = {}, action) => {
   switch (action.type) {
      case CATEGORY_NAME_VALIDATE_REQUEST:
         return { loading: true };
      case CATEGORY_NAME_VALIDATE_SUCCESS:
         return { loading: false, validation: action.payload };
      case CATEGORY_NAME_VALIDATE_FAIL:
         return { loading: false, error: action.payload };
      default:
         return state;
   }
};

